import SelectInput from "../../../../component/SelectInput";
import {ApiUrl} from "../../../../auth/authMethods";
import CurrencyInput from "../../../../component/CurrencyInput";
import TextField from "@mui/material/TextField";
import {InputLabelProps} from "../../../../utils/InputLabelProps";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {handleChangeData} from "../../../../utils/handleChangeData";
import React, {useEffect, useState} from "react";
import applyRegex from "../../../../utils/applyRegex";
import {handleChangeValue} from "../../../../utils/handleChangeValue";
import DisplayManyUsers from "../../../Order/Components/InputsAddInstallmentPattern/DisplayManyUsers";
import Box from "@mui/material/Box";


export default function InputsPreviewAntecipacao({setRequestBody}) {

    const [valorOriginal, setValorOriginal] = useState(0);
    const [desconto, setDesconto] = useState(0);
    const [valor, setValor] = useState(0);
    const [diaDoMes, setDiaDoMes] = useState(null)
    const [primeiroVencimento, setPrimeiroVencimento] = useState(null)

    const [padraoParcelamentoId, setPadraoParcelamentoId] = useState('')
    const [padraoParcelamentoList, setPadraoParcelamentoList] = useState([])
    const [blockSubmit, setBlockSubmit] = useState(false);


    useEffect(() => {
        setValor(valorOriginal - (desconto ? desconto : 0))
    }, [valorOriginal, desconto])

    const handleChangeNumber = (set, value) => {
        const intValue = parseInt(applyRegex(value.replace('e', ''), /\d+/))
        set(intValue ? intValue : '')
    }

    const [compradores, setCompradores] = useState([{
        index: 0,
        papel: 'COMPRADOR'
    }])
    const [fundos, setFundos] = useState([{
        index: 0,
        papel: 'FUNDO'
    }])
    const [vendedores, setVendedores] = useState([{
        index: 0,
        papel: 'VENDEDOR'
    }])

    useEffect(() => {
        setRequestBody(prevData => {
            return {
                ...prevData,
                padraoParcelamentoId,
                primeiroVencimento: primeiroVencimento + 'T00:00:00',
                diaDoMes,
                valor,
                users: [...compradores, ...vendedores,...fundos]
            }
        })
    }, [
        padraoParcelamentoId,
        primeiroVencimento,
        valor, diaDoMes, compradores,
        vendedores,fundos
    ])

    return <>
        <CurrencyInput
            label="Valor Original"
            customInput={TextField}
            prefix='R$'
            value={valorOriginal}
            inputProps={{
                min: 1,
                step: ".01"
            }}
            onValueChange={(e) => handleChangeValue(e, setValorOriginal)}
            InputLabelProps={InputLabelProps}
            required
            fullWidth
        />
        <CurrencyInput
            label="Desconto"
            value={desconto}
            inputProps={{
                min: 0,
                step: ".01"
            }}
            onValueChange={(e) => handleChangeValue(e, setDesconto)}
            InputLabelProps={InputLabelProps}
            required
            fullWidth
        />
        <CurrencyInput
            label="Valor Líquido das Parcelas"
            value={valor}
            inputProps={{
                readOnly: true,
                min: 1,
                step: ".01"
            }}
            onValueChange={(e) => handleChangeValue(e, setValor)}
            InputLabelProps={InputLabelProps}
            required
            fullWidth
        />

        <SelectInput
            url={ApiUrl + '/padrao-parcelamento/list?size=20000'}
            list={padraoParcelamentoList}
            set={setPadraoParcelamentoList}
            defaultValue={padraoParcelamentoId}
            setObj={setPadraoParcelamentoId}
            returnList={() => {
                let returnList = []
                padraoParcelamentoList.forEach((item) => {
                    returnList.push({value: item.id, label: `${item.nome}`})
                })
                return returnList
            }}
            placeholder={"Padrão de parcelamento *"}
            required={true}
            fullWidth
        />

        <TextField
            label="Dia de Vencimento"
            type="text"
            className='mt-2'
            value={diaDoMes}
            inputProps={{
                minLength: 1,
                maxLength: 2
            }}
            onChange={(e) => handleChangeNumber(setDiaDoMes, e.target.value)}
            InputLabelProps={InputLabelProps}
            required
            fullWidth
        />

        <DatePicker
            label="Data de Vencimento da primeira parcela boletada"
            sx={{
                width: '100%',
                zIndex: 0
            }}
            defaultValue={primeiroVencimento ? dayjs(primeiroVencimento) : null}
            onChange={(e) => handleChangeData(e, setPrimeiroVencimento)}
            slotProps={{
                textField: {
                    required: true,
                },
            }}
            InputLabelProps={InputLabelProps}
        />

        <Box mt={2} component={'h5'}>
            Vendedores
        </Box>
        <hr/>
        <DisplayManyUsers
            obj={vendedores} setObj={setVendedores}
            name={'Vendedor'} type={'VENDEDOR'} setBlockSubmit={setBlockSubmit}
        />

        <Box mt={2} component={'h5'}>
            Compradores
        </Box>
        <hr/>
        <DisplayManyUsers
            obj={compradores} setObj={setCompradores}
            name={'Comprador'} type={'COMPRADOR'} setBlockSubmit={setBlockSubmit}
        />
        <hr/>

        <Box mt={2} component={'h5'}>
            Fundo(s)
        </Box>
        <hr/>
        <DisplayManyUsers
            obj={fundos} setObj={setFundos}
            isFundo={true} setBlockSubmit={setBlockSubmit}
            name={'Fundo'} type={'FUNDO'}
        />
        <hr/>
    </>
}